import { AppState } from 'services/types';
import { SprayEventStartDate } from 'services/sprayEvents/types';
import {
    SprayedEntitiesByDateRequestProps,
    SprayedEntitiesByDateState
} from './types';

const selectStartDate = (
    state: AppState,
    props: SprayedEntitiesByDateRequestProps
): SprayEventStartDate => props.startDate;

const selectSprayedEntitiesByDate = (
    state: AppState
): SprayedEntitiesByDateState => state.sprayedEntitiesByDate;

export { selectStartDate, selectSprayedEntitiesByDate };
